import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Directive({
  selector: '[hasRoles]',
})
export class HasRolesDirective implements OnInit {
  private isAdmin: boolean = false;
  private morphologyRoles: string[] = [];
  private rolesToCheck: string[] = [];

  private created = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private oauthService: OAuthService
  ) {
    if (this.oauthService.hasValidAccessToken()) {
      const token = this.oauthService.getIdentityClaims() as any;
      if (token) {
        if (token.role && token.role.includes('SuperAdmin')) {
          this.isAdmin = true;
        }
        if (token.morphology_role) {
          if (typeof token.morphology_role == 'string') {
            this.morphologyRoles.push(token.morphology_role);
          } else {
            this.morphologyRoles = token.morphology_role;
          }
        }
      }
    }
  }

  ngOnInit(): void {}

  @Input()
  set hasRoles(roles: string[]) {
    this.rolesToCheck = roles;
    this.updateView();
  }

  private updateView() {
    if (this.checkRoles()) {
      if (!this.created) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.created = true;
      }
    } else {
      this.viewContainer.clear();
      this.created = false;
    }
  }

  private checkRoles() {
    let hasRole = false;

    if (this.isAdmin) {
      return true;
    }
    if (this.rolesToCheck && this.morphologyRoles) {
      hasRole = this.morphologyRoles.some((x) => {
        return this.rolesToCheck.some((y) => x == y);
      });
    }
    return hasRole;
  }
}
